import "./App.css";
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import Experience from "./pages/Experience";
import About from "./pages/About";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProjectDisplay from "./pages/ProjectDisplay";
import { useEffect } from "react";

function SolmuRedirect() {
  useEffect(() => {
    window.location.href = "http://cgmd-frontend-1770139819.s3-website-us-east-1.amazonaws.com";
  }, []);
  return null;
}

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/project/:id" element={<ProjectDisplay />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/about" element={<About />} />
          <Route path="/solmu" element={<SolmuRedirect />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
